import React from "react";
import SensorBase from "./SensorBase";
import IrrigationHour from "../../../components/IrrigationHour";
import { TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";
import { TCustomProcessFn } from "../types";
import { generateColorForItem } from "../util";

const FIELD = "moisture1";
const UNIT = "%";

const customProcessFn: TCustomProcessFn = (
  graphData: TSensorDataResponse 
) => {
 
  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForItem(
      Number(item.moisture1),
      item.minThresholdValue,
      item.minOptimalValue,
      item.maxOptimalValue,
      item.maxThresholdValue
    ),   
  }));

  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,  
    color: updatedSample.map((item) => item.color),  
  };
};
const Moisture1: React.FC = () => {
  return (
    <div>
      <SensorBase field={FIELD} unit={UNIT} customProcessFn={customProcessFn}></SensorBase>
      <IrrigationHour />
    </div>
  );
};

export default Moisture1;
